import { PackagingType } from "types/packaging";
import apiClient from "./apiClient";
import { getAuthHeader } from "@utils/getAuthHeader";

export const fetchPackagingTypes = async (): Promise<PackagingType[]> => {
	try {
		const response = await apiClient.get("/packaging-type/", {
			headers: {
				Authorization: getAuthHeader(),
			},
		});
		return response.data.data;
	} catch (error) {
		console.error("Error fetching packaging types:", error);
		throw error;
	}
};
